import React, {memo, useCallback, useMemo, useState} from "react";
import {Tabs, Typography} from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import {makeStyles} from "@material-ui/core/styles";
import {useCollectionData} from "react-firebase-hooks/firestore";
import ModerationTable from "./ModerationTable";
import {ItemStatuses} from "../../../constants";
import {Link} from "react-router-dom";

const useStyles = makeStyles({
    root: {
        color: 'white'
    },
    tabsRoot: {
        display: 'flex',
        justifyContent: 'center'
    },
    contentRoot: {
        display: 'flex',
        justifyContent: 'center'
    },
    title: {
        margin: '1vw auto'
    }
})

const len = arr => arr ? arr.length : '--'

const ModerationPage = ({label, tableRef, link, users, linkLabel}) => {
    const [tab, setTab] = useState(0)

    const classes = useStyles()

    const handleTabChange = useCallback((e, newValue) => {
        setTab(newValue)
    }, [])

    const [tableData] = useCollectionData(tableRef.orderBy('timestamp', 'desc'), {idField: 'id'})

    const dataWithAuthor = useMemo(
        () => tableData ? tableData.map(i => ({...i, author: users.find(u => u.CustID === i.userId)})) : null,
        [tableData, users])

    const submitted = useMemo(
        () => dataWithAuthor ? dataWithAuthor.filter(_ => _.status === ItemStatuses.SUBMITTED) : null,
        [dataWithAuthor]
    )
    const approved = useMemo(
        () => dataWithAuthor ? dataWithAuthor.filter(_ => _.status === ItemStatuses.APPROVED) : null,
    [dataWithAuthor]
    )
    const rejected = useMemo(
        () => dataWithAuthor ? dataWithAuthor.filter(_ => _.status === ItemStatuses.REJECTED) : null,
    [dataWithAuthor]
    )

    const onApprove = useCallback(id => {
        tableRef.doc(id).set({status: ItemStatuses.APPROVED}, {merge: true})
    }, [])

    const onReject = useCallback(id => {
        tableRef.doc(id).set({status: ItemStatuses.REJECTED}, {merge: true})
    }, [])

    return (<div className={classes.root}>
        <Typography variant='h4' className={classes.title}>{label}</Typography>
        <Link to={link}><Typography>({linkLabel})</Typography></Link>
        <Tabs centered value={tab} onChange={handleTabChange}>
            <Tab label={`Submitted (${len(submitted)})`}/>
            <Tab label={`Approved (${len(approved)})`}/>
            <Tab label={`Rejected (${len(rejected)})`}/>
        </Tabs>

        <div className={classes.contentRoot}>
            {tab === 0 && <ModerationTable items={submitted} onApprove={onApprove} onReject={onReject}/>}
            {tab === 1 && <ModerationTable items={approved} onReject={onReject}/>}
            {tab === 2 && <ModerationTable items={rejected} onApprove={onApprove}/>}
        </div>
    </div>)
}

export default memo(ModerationPage)